// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

.container_sobre {
  margin: 2em auto;
  padding: clamp(1em, 3vw, 2em);
  max-width: 1200px;
  font-size: clamp(1rem, 1.2vw, 1.2rem);
  line-height: 1.6;
  color: #222;
}

.container_sobre h1 {
  font-weight: bold;
  font-size: clamp(1.6rem, 2.5vw, 2.2rem);
  margin-bottom: 0.8em;
}

.container_sobre h2 {
  font-weight: 600;
  font-size: clamp(1.3rem, 2vw, 1.7rem);
  margin: 1.5em 0 1em;
}

.caixa_texto_img {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2em;
  margin: 2em 0 3em;
  flex-wrap: wrap;
}

.caixa_texto_img span {
  width: 55%;
  text-align: justify;
}

.caixa_texto_img div {
  width: 40%;
  display: flex;
  justify-content: center;
}

.caixa_texto_img img {
  width: 100%;
  max-width: 350px;
  height: auto;
  object-fit: contain;
}

.caixa_sobre_lab {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2em;
  margin: 3em 0;
  flex-wrap: wrap;
}

.caixa_sobre_lab div {
  width: 55%;
  text-align: justify;
}

.caixa_sobre_lab > p {
  width: 40%;
  text-align: justify;
}

.caixa_sobre_conexao {
  margin-top: 2em;
  text-align: justify;
}

.p_negrito {
  font-weight: bolder;
  margin-top: 1em;
  margin-bottom: 1.2em;
  text-align: left;
}

.img_labers {
  margin-top: 3em;
  width: 100%;
  display: flex;
  justify-content: center;
}

.img_labers img {
  width: 100%;
  max-width: 1200px;
  height: auto;
  border-radius: 2em;
}


@media (max-width: 950px) {
  .caixa_texto_img span,
  .caixa_sobre_lab div,
  .caixa_sobre_lab > p {
    width: 100%;
  }

  .caixa_texto_img,
  .caixa_sobre_lab {
    gap: 1.5em;
  }

  .caixa_texto_img img {
    max-width: 300px;
  }
}

@media (max-width: 600px) {
  .container_sobre {
    padding: 1em;
  }

  .container_sobre h1 {
    font-size: 1.5rem;
  }

  .container_sobre h2 {
    font-size: 1.3rem;
  }

  .img_labers img {
    border-radius: 1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/paginas/aluno/SobreAlunos.css"],"names":[],"mappings":"AAAA;;;EAGE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE;;;IAGE,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["html,\nbody,\n#root {\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n}\n\n.container_sobre {\n  margin: 2em auto;\n  padding: clamp(1em, 3vw, 2em);\n  max-width: 1200px;\n  font-size: clamp(1rem, 1.2vw, 1.2rem);\n  line-height: 1.6;\n  color: #222;\n}\n\n.container_sobre h1 {\n  font-weight: bold;\n  font-size: clamp(1.6rem, 2.5vw, 2.2rem);\n  margin-bottom: 0.8em;\n}\n\n.container_sobre h2 {\n  font-weight: 600;\n  font-size: clamp(1.3rem, 2vw, 1.7rem);\n  margin: 1.5em 0 1em;\n}\n\n.caixa_texto_img {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 2em;\n  margin: 2em 0 3em;\n  flex-wrap: wrap;\n}\n\n.caixa_texto_img span {\n  width: 55%;\n  text-align: justify;\n}\n\n.caixa_texto_img div {\n  width: 40%;\n  display: flex;\n  justify-content: center;\n}\n\n.caixa_texto_img img {\n  width: 100%;\n  max-width: 350px;\n  height: auto;\n  object-fit: contain;\n}\n\n.caixa_sobre_lab {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 2em;\n  margin: 3em 0;\n  flex-wrap: wrap;\n}\n\n.caixa_sobre_lab div {\n  width: 55%;\n  text-align: justify;\n}\n\n.caixa_sobre_lab > p {\n  width: 40%;\n  text-align: justify;\n}\n\n.caixa_sobre_conexao {\n  margin-top: 2em;\n  text-align: justify;\n}\n\n.p_negrito {\n  font-weight: bolder;\n  margin-top: 1em;\n  margin-bottom: 1.2em;\n  text-align: left;\n}\n\n.img_labers {\n  margin-top: 3em;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.img_labers img {\n  width: 100%;\n  max-width: 1200px;\n  height: auto;\n  border-radius: 2em;\n}\n\n\n@media (max-width: 950px) {\n  .caixa_texto_img span,\n  .caixa_sobre_lab div,\n  .caixa_sobre_lab > p {\n    width: 100%;\n  }\n\n  .caixa_texto_img,\n  .caixa_sobre_lab {\n    gap: 1.5em;\n  }\n\n  .caixa_texto_img img {\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 600px) {\n  .container_sobre {\n    padding: 1em;\n  }\n\n  .container_sobre h1 {\n    font-size: 1.5rem;\n  }\n\n  .container_sobre h2 {\n    font-size: 1.3rem;\n  }\n\n  .img_labers img {\n    border-radius: 1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
